export const PROFILE = {
  name: "Jahanzaib Khan",
  title: "Full Stack Developer | PHP | Node.js | React | Database Architect",
  city: "Karachi",
  country: "Pakistan",
  email: "mjahanzaib5@gmail.com",
  phone: "+923213609115",
  shortBio:
    "Versatile Full Stack Developer with extensive experience in building robust web applications from concept to deployment. Proficient in both frontend and backend technologies including React, PHP, Node.js, MySQL, and MongoDB. I create seamless user experiences backed by scalable and secure server-side architectures.",
  heroCTA: "Let's work together"
};

export const SKILLS = [
  "React.js",
  "JavaScript (ES6+)",
  "HTML5 & CSS3",
  "PHP",
  "Node.js",
  "MySQL",
  "MongoDB",
  "PostgreSQL",
  "RESTful APIs",
  "GraphQL",
  "Express.js",
  "Laravel",
  "Database Design",
  "Server Management",
  "AWS",
  "Git/GitHub",
  "Docker",
  "CI/CD",
  "Optimization"
];

export const EXPERIENCE = [
  {
    role: "Senior Full Stack Developer",
    company: "Fascom Limited",
    period: "Feb, 2022 — Dec, 2025",
    details: [
      "Architecting scalable full-stack solutions using Node.js, Express, and React.",
      "Managing complex database schemas in MongoDB and PostgreSQL.",
      "Developing responsive and interactive user interfaces.",
      "Optimizing application performance and ensuring high availability.",
      "Integrating third-party services and payment gateways."
    ]
  },
  {
    role: "Full Stack Developer",
    company: "Levnine Digital",
    period: "July 2020 — January 2022",
    details: [
      "Custom WordPress theme and plugin development using PHP, MySQL, and JavaScript.",
      "Database query optimization for high-traffic websites.",
      "Developing secure REST APIs and consuming them in modern frontend applications.",
      "Migrating legacy systems to modern full-stack architectures."
    ]
  },
  {
    role: "Full Stack Developer",
    company: "ePlanet Communications Inc",
    period: "May 2019 — June 2020",
    details: [
      "Building robust, end-to-end web applications and managing database interactions.",
      "Ensuring cross-browser compatibility and mobile responsiveness.",
      "Collaborating with cross-functional teams to deliver seamless data integration."
    ]
  }
];

export const PROJECTS = [
  // {
  //   name: "Me2uPay",
  //   url: "https://me2upay.se/",
  //   thumbnail: "/images/projects/5.jpg",
  //   details: "PHP/Inertia Full Stack Application"
  // },
  {
    name: "Vic Firth",
    url: "https://vicfirth.com/",
    thumbnail: "/images/projects/12.jpg",
    details: "Custom WordPress Development"
  },
  {
    name: "Likely Story",
    url: "https://likely-story.co.uk/",
    thumbnail: "/images/projects/13.jpg",
    details: "Full Stack Development & Optimization"
  },
  {
    name: "Balaala Beauty Care",
    url: "https://balaalabeautycare.com/",
    thumbnail: "/images/projects/30.jpg",
    details: "Shopify Full Stack Customization"
  },
  {
    name: "Snoozy Nest",
    url: "https://snoozynest.com/",
    thumbnail: "/images/projects/31.jpg",
    details: "E-commerce Full Stack Solution"
  },
  {
    name: "La Republica Food",
    url: "https://larepublicasuperfoods.com/",
    thumbnail: "/images/projects/17.jpg",
    details: "API Integration & Frontend Dev"
  },
  {
    name: "Craft 9 Studios",
    url: "https://www.craft9studios.com/",
    thumbnail: "/images/projects/1.jpg",
    details: "MERN Stack Application"
  },
  {
    name: "Shifaam",
    url: "https://www.shifaam.com/",
    thumbnail: "/images/projects/6.jpg",
    details: "Healthcare Management Portal"
  },
  {
    name: "Activ Communication",
    url: "https://www.activcommunication.fr/",
    thumbnail: "/images/projects/8-1.jpg",
    details: "Full Stack PHP Development"
  },
  {
    name: "Dilate",
    url: "https://www.dilate.com.au/",
    thumbnail: "/images/projects/9-1.jpg",
    details: "Bespoke System Architecture"
  },
  {
    name: "Nalgene",
    url: "https://nalgene.com/",
    thumbnail: "/images/projects/9-3.jpg",
    details: "Full Stack Performance Tuning"
  },
  {
    name: "Coronet Kitchens",
    url: "https://www.coronetkitchens.com/",
    thumbnail: "/images/projects/9-2.jpg",
    details: "CMS Customization & Frontend"
  },
  {
    name: "Bike Room",
    url: "https://bike-room.com/",
    thumbnail: "/images/projects/9-6.jpg",
    details: "Data Migration & UI Sync"
  },
  {
    name: "Hexagon Architecture",
    url: "https://hxg.eu/",
    thumbnail: "/images/projects/10-1.jpg",
    details: "PostgreSQL & Frontend Integration"
  },
  {
    name: "ElevenThirtySix",
    url: "https://itseleventhirtysix.com/",
    thumbnail: "/images/projects/9.jpg",
    details: "Full Stack API Development"
  },
  {
    name: "NAPA",
    url: "https://napa.org.pk/",
    thumbnail: "/images/projects/10.jpg",
    details: "Educational Portal Full Stack"
  },
  {
    name: "TGI Luxury",
    url: "https://tgiluxury.com/",
    thumbnail: "/images/projects/11.jpg",
    details: "Luxury Retail Web App"
  },
  // {
  //   name: "EnterAkt",
  //   url: "https://enterakt.com/",
  //   thumbnail: "/images/projects/15.jpg",
  //   details: "Interactive System Full Stack"
  // },
  {
    name: "Server4Sale",
    url: "https://www.server4sale.com.pk/",
    thumbnail: "/images/projects/16.jpg",
    details: "Hosting Infrastructure & Web UI"
  },
  {
    name: "Book Riot",
    url: "https://bookriot.com/",
    thumbnail: "/images/projects/16-1.jpg",
    details: "High-Traffic Full Stack App"
  }
];

export const SOCIALS = [
  /// { label: "GitHub", url: "https://github.com/jahanzaibkhan" },
  { label: "WhatsApp", url: "https://wa.me/+923213609115" },
  // { label: "LinkedIn", url: "https://www.linkedin.com/in/jahanzaib-khan-manager/" },
  // { label: "Dribbble", url: "https://dribbble.com/jahanzaibkhan" }
];
